/**
 * Заглушка главной: пользователь без доступа к дашбордам (или с несколькими — после входа).
 */

import React from 'react';
import '../styles/WelcomePage.css';

const WelcomePage: React.FC = () => {
  return (
    <div className="welcome-page">
      <h1>Добро пожаловать в систему «UniCore» — информационное ядро компании «Универстрой»!</h1>
      <p>
        Вам доступны страницы, модули, договоры, задачи и статьи расходов согласно выданным ролям
        и назначениям. Для получения дополнительных доступов обратитесь к Администратору системы.
      </p>
    </div>
  );
};

export default WelcomePage;
